import { render, staticRenderFns } from "./doc-menu.vue?vue&type=template&id=05ef6e99"
import script from "./doc-menu.vue?vue&type=script&lang=js"
export * from "./doc-menu.vue?vue&type=script&lang=js"
import style0 from "./doc-menu.vue?vue&type=style&index=0&id=05ef6e99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports